import React from "react";
import { useLocation } from "react-router";

import { GoogleOAuthProvider } from "@react-oauth/google";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import Divider from "components/Divider";
import AuthLayout from "layouts/AuthLayout";

import AppButtons from "../AppButtons";
import AuthForm from "./AuthForm";
import LegalDisclaimer from "./LegalDisclaimer";

import { getReactAppConfig } from "shared/functions";

const Auth: React.FC = () => {
  const location = useLocation();

  const config = getReactAppConfig();

  const from = location.state?.from;

  const GOOGLE_CLIENT_ID = config.GOOGLE_CLIENT_ID;

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthLayout>
        <Paper
          sx={{ width: { xs: "100%", sm: "480px" }, m: 2 }}
          data-testid="auth-form-box"
        >
          <Typography sx={{ mb: 3 }} variant="h5">
            Увійдіть або створіть профіль
          </Typography>
          <AppButtons from={from} />

          <Box sx={{ m: "24px 0" }}>
            <Divider text="або" />
          </Box>

          <AuthForm />

          <LegalDisclaimer />
        </Paper>
      </AuthLayout>
    </GoogleOAuthProvider>
  );
};

export default Auth;
